import type { LegalLink } from '../types/content'

export const siteConfig = {
  brandName: 'L’Atelier delle Vetrate Creative',

  /** Prezzo unico del kit (approvato). */
  price: '19 €',

  /** Locale della pagina. */
  locale: 'it-IT',

  /** URL di pagamento per l’Italia (confermato). */
  checkoutUrl:
    'https://l-atelier-delle-vetrate-creative.impultienda.ar/checkout/l-atelier-delle-vetrate-creative',

  /**
   * Video verticale (4:5) della prima sezione. Non modificare.
   * Vuoto = viene mostrata l’immagine della guida principale.
   */
  heroVideoUrl: 'https://cdn.magicpatterns.com/uploads/mtNcZvneeEfuUXhTHscNW1/hero.mp4',

  /**
   * Prova sociale presente nella fonte originale (valutazione media aggregata
   * e numero di clienti). Tradotta senza modifiche: non è un dato del mercato italiano.
   */
  trust: {
    rating: 4.9 as number | null,
    customerLabel: 'Oltre 3.100 clienti si fidano di noi',
  },

  /** ID Meta Pixel dell’account Italia (approvato). Vuoto = non caricato. */
  metaPixelId: '1605479694958491',

  /**
   * Risposta FAQ «Come ricevo i file?»
   * Da scrivere in base alla modalità di consegna reale. Vuoto = domanda nascosta.
   */
  deliveryAnswer: '',

  /**
   * Risposta FAQ «Posso vendere le mie creazioni?»
   * Da scrivere in base ai diritti d’uso confermati dei modelli. Vuoto = domanda nascosta.
   */
  commercialUseAnswer: '',

  /** Link del footer. Vengono mostrati solo i link con un URL. */
  legalLinks: [
    { label: 'Contatti', href: '' },
    { label: 'Termini e condizioni', href: '' },
    { label: 'Informativa sulla privacy', href: '' },
    { label: 'Contenuti digitali e diritto di recesso', href: '' },
  ] as LegalLink[],
}
